<template>
    <div class="header-search__form" :class="{'p-0' : $ceres.isShopBuilder, 'header-search__form--open': searchOpen || isMobile}">
        <div class="input-group">
          <label for="headerSearch" class="d-none">itemSearchSearchTerm</label>
            <input id="headerSearch" type="search" class="header-search__input form-control" :placeholder="$translate('Ceres::Template.itemSearchSearchTerm')" ref="searchInput" v-model="searchString" @input="onValueChanged($event.target.value)"
                @keyup.enter="search()" @focus="isSearchFocused = true" @blur="onBlurSearchField($event)" :autofocus="isShopBuilder" :aria-label="$translate('Ceres::Template.headerSearchTerm')">
            <slot name="search-button">
                <div class="input-group-append">
                    <button class="btn header-search__btn" type="submit" @click="openSearch()" aria-label="Search" :aria-label="$translate('Ceres::Template.headerSearch')">
                        <svg class="icon icon-search" fill="currentColor">
                            <use xlink:href="#search" />
                        </svg>
                    </button>
                </div>
            </slot>
            <template v-if="isSearchFocused">
                <div v-show="hasAutocompleteResults">
                    <slot name="autocomplete-suggestions">
                        <div class="autocomplete-suggestions">
                            <search-suggestion-item
                                    :show-images="showItemImages"
                                    suggestion-type="item">
                            </search-suggestion-item>
                        </div>
                    </slot>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import UrlService from "ceres/app/services/UrlService";
    import {
        isNullOrUndefined,
        defaultValue
    } from "ceres/app/helper/utils";
    import {
        pathnameEquals
    } from "ceres/app/helper/url";
    import ApiService from "ceres/app/services/ApiService";
    import {
        mapState
    } from 'vuex';
    import {
        debounce
    } from 'ceres/app/helper/debounce';

    export default {

        name: "item-search",

        props: {
            showItemImages:
                {
                    type: Boolean
                },
            forwardToSingleItem:
                {
                    type: Boolean,
                    default: App.config.search.forwardToSingleItem
                },
            timeout:
                {
                    type: Number,
                    default: 200
                }
        },

        data()
        {
            return {
                isSearchFocused: App.isShopBuilder,
                onValueChanged: null,
                searchString: "",
                isMobile: false,
                searchOpen: false,
            };
        },



        computed:
            {
                hasAutocompleteResults()
                {
                    const item       = this.autocompleteResult.item;
                    const category   = this.autocompleteResult.category;
                    const suggestion = this.autocompleteResult.suggestion;

                    return App.isShopBuilder || (item && item.length) || (category && category.length) || (suggestion && suggestion.length);
                },

                isShopBuilder()
                {
                    return App.isShopBuilder;
                },

                ...mapState({
                    autocompleteResult: state => state.itemSearch.autocompleteResult,
                    moduleSearchString: state => state.itemList.searchString
                })
            },

        mounted()
        {

            this.isMobile = window.innerWidth < 768;
            this.searchOpen = this.isMobile

            this.onValueChanged = debounce(searchString =>
            {
                this.autocomplete(searchString);
            }, defaultValue(this.timeout, 200));

            this.$nextTick(() =>
            {
                const urlParams = UrlService.getUrlParams(document.location.search);

                this.$store.commit("setItemListSearchString", urlParams.query);

                this.$refs.searchInput.value = !isNullOrUndefined(urlParams.query) ? urlParams.query : "";
            });
        },

        methods:
            {
                search()
                {
                    if (this.$refs.searchInput.value.length)
                    {
                        if (pathnameEquals(App.urls.search))
                        {
                            this.$store.dispatch("searchItems", this.$refs.searchInput.value);
                        }
                        else
                        {
                            window.open(`${App.urls.search}?query=${ this.searchString }`, "_self", false);
                        }
                    }
                },

              openSearch(){
                  if((this.searchString === "" || this.searchOpen === false) && !this.isMobile ){
                    if(this.searchOpen){
                      this.searchOpen = false
                    }
                    else{
                      this.searchOpen = true
                    }
                  }
                  else{
                    this.search()
                  }

              },

                autocomplete(searchString)
                {
                    if (searchString.length >= 2)
                    {
                        this.$store.dispatch("loadItemSearchAutocomplete", searchString);
                    }
                    else
                    {
                        this.$store.commit("setAutocompleteResult", { item: [], category: [], suggestion: [] });
                    }
                },

                // hide search, if targetElement of the blur event is not a child of components' root element
                onBlurSearchField(event)
                {
                    const target = event.relatedTarget;

                    if (isNullOrUndefined(target) || !isNullOrUndefined(target) && !this.$el.contains(target))
                    {
                        this.isSearchFocused = false;
                    }
                }
            },

        watch:
            {
                // set the current search string, after clicking on a suggestion
                moduleSearchString(newVal)
                {
                    if (newVal && newVal.length)
                    {
                        this.searchString = newVal;
                    }
                }
            }
    }
</script>
